import { render, staticRenderFns } from "./PurchasesImporter.vue?vue&type=template&id=a455b6ae&"
import script from "./PurchasesImporter.vue?vue&type=script&lang=js&"
export * from "./PurchasesImporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports